<template>
  <div class="mini-hub mini-book">
    <div class="inner">
      <etiquette
        v-bind:post-type="post.type"
        :etiquette-type="post.etiquette_type"
      />
      <h3 class="title" v-html="title_linked"></h3>

      <tags :tagsArray="post.tags" />
    </div>
    <Button :link="post.link" :postType="post.type" />
    <div
      class="contentImg"
      id="img_backgroundEl"
      :style="{ backgroundImage: `url(${post.featured_image_url})` }"
    ></div>
  </div>
</template>

<script>
import Etiquette from "../parts/Etiquette";
import Button from "../parts/Button";
import Tags from "../parts/Tags";

export default {
  name: "BookView",
  components: {
    Etiquette,
    Button,
    Tags,
  },

  props: {
    post: Object,
  },
  computed: {
    title_linked: function () {
      return (
        '<a href="' + this.post.link + '">' + this.post.title.rendered + "</a>"
      );
    },
  },
};
</script>
